export enum PalletPassportField {
    BOXES = 'boxes',
    GROSS_WEIGHT = 'grossWeight',
    PALLET_WEIGHT = 'palletWeight',
    BOX_WEIGHT = 'boxWeight',
}